import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import {UnitRatingRequest} from '../../model/unit-rating-request';
import {UnitConversionUtils} from '../../configurator/unit-conversion-utils';
import {CoilRequestComponent} from '../coil-request/coil-request.component';


@Component({
    selector: 'app-candidate-rating-input',
    templateUrl: './candidate-rating-input.component.html',
    styleUrls: ['./candidate-rating-input.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CoilRequestComponent]
})
export class CandidateRatingInputComponent {

  readonly ratingRequest = input.required<UnitRatingRequest>();
  readonly metricInput = input.required<boolean>();

  getAirflowUnits(): string {
    return UnitConversionUtils.getAirflowUnits(this.metricInput());
  }

  getAltitudeUnits(): string {
    return UnitConversionUtils.getLengthUnits(this.metricInput());
  }

  getEspUnits(): string {
    return UnitConversionUtils.getEspUnits(this.metricInput());
  }

}
